import React from 'react';
import clubsArg from '../../data/clubsArg.json';
import TeamSelector from './TeamSelector';

// Misma pantalla de selección que la versión mundial, cambiando sólo el set de clubes.
// Antes era una copia completa del componente; ahora TeamSelector recibe los clubes por
// prop, así el rediseño y cualquier arreglo futuro valen para los dos juegos.
const TeamSelectorArg = ({ onSelect }) => (
    <TeamSelector onSelect={onSelect} clubs={clubsArg} />
);

export default TeamSelectorArg;
